import $ from 'jquery';
import actions from '@wc-stripe/actions';

// FunnelKit's smart-buttons script watches each express slot with a MutationObserver
// (`domInsert`) and reveals the row once every slot has reported ready or unavailable.
// Drop a marker into the slot as soon as our gateway resolves so it settles right away
// instead of waiting out FunnelKit's per-slot deadline.
//
// The `<span>` guard means whichever event fires first wins; for express gateways the
// first resolution is terminal (server availability + wallet eligibility are both
// cached), so it's always the correct one.

// Available: mounted - fires right after .mount(), before the iframe finishes rendering.
actions.addAction('payment_element_ready', controller => {
	const id = controller && controller.gateway && controller.gateway.id;
	const slot = id && document.querySelector(`.banner_payment_method_${id}`);
	if (slot && !slot.querySelector('span')) {
		$(slot).append('<span style="display:none;"></span>');
	}
});

// Unavailable: FunnelKit's `domInsert` / `markUnavailable` looks for a `.wfacp_reject_button`
// child to settle a slot as rejected.
actions.addAction('payment_unavailable', controller => {
	const id = controller && controller.gateway && controller.gateway.id;
	const slot = id && document.querySelector(`.banner_payment_method_${id}`);
	if (slot && !slot.querySelector('span')) {
		$(slot).append('<span class="wfacp_reject_button" style="display:none;"></span>');
	}
});